<script setup>
import { ref, computed } from "vue"
import { guid } from '@/common/helper.js'

const uniqueId = ref(guid());

const props = defineProps({
  label: {
    type: String,
    default: null
  },
  enabled: {
    type: Boolean,
    default: true
  },
  readonly: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue']);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    if (props.readonly) {
      return; //Skip changing
    }
    emit('update:modelValue', value);
  }
});
</script>

<template>
  <div class="flex gap-2 items-baseline">
    <input type="checkbox" :id="uniqueId" v-model="value" :disabled="!props.enabled" />
    <label :for="uniqueId" :id="'label-for-' + uniqueId" class="label" :class="{ 'label-inactive': !props.enabled }" v-if="label"><slot>{{ label }}</slot></label>
  </div>
</template>

<style scoped>
.label {
  @apply block text-sm font-medium text-gray-900 dark:text-white relative -top-0.5;
}

.label-inactive {
  @apply text-gray-400 dark:text-gray-400;
}

input[type='checkbox']:disabled {
  @apply bg-gray-200 border-gray-400 dark:bg-gray-700;
}
</style>
